'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { template } from '#pplx/frontend/framework/templates/template.js';
const SidebarPrimarySlotRoot = ({ children, ref }) => (_jsx("div", { ref: ref, "data-upsell-slot": "ask.sidebar.primary", children: children }));
const SidebarUpsellSlotsLayout = ({ Slot, }) => _jsx(Slot, { slot: "primary" });
export const SidebarUpsellSlotsTemplate = template('SidebarUpsellSlotsTemplate')
    .slot('primary', SidebarPrimarySlotRoot)
    .define(SidebarUpsellSlotsLayout);
//# sourceMappingURL=SidebarUpsellSlotsTemplate.js.map